import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { iStore } from '~/domain/interfaces/models';
import { makeReduxDataPagination } from '~/main/factories/usecases/dataPagination/SetDataFactory';
import { ListEmpty } from '../componentEmpty';
import { translator } from '../i18n';
import { RegisteredParticipant } from './Lists';

const ListRegisteredParticipant: React.FC = () => {
  const { dataPagination } = useSelector(
    (store: iStore) => store.dataPagination,
  );
  const { loading } = useSelector((store: iStore) => store.users);
  useEffect(() => {
    makeReduxDataPagination().set([]);
    // return () => {
    // };
  }, []);

  return dataPagination.length === 0 && !loading ? (
    <ListEmpty
      message={translator(
        'Os pacientes cadastrados aparecerão aqui. No momento não há nenhum',
      )}
    />
  ) : (
    <RegisteredParticipant dataList={dataPagination} />
  );
};

export default ListRegisteredParticipant;
